import _ from 'lodash';

export const convertQueryToFormFieldOfDetails = (fieldName, value) => {
  switch (fieldName) {
    case 'client_branch_ids':
      return { offices: value.replace(/_/g, ',') };
    case 'group_ids':
      return { groups: value.replace(/_/g, ',') };
    case 'position_ids':
      return { positions: value.split('_') };
    case 'employment_type_ids':
      return { employmentTypes: value.split('_') };
    case 'occupation_ids':
      return { occupations: value.split('_') };
    case 'memo_color_ids':
      return { memoColors: value.split('_') };
    case 'payroll_rule_group':
      return { payrollRuleGroup: value };
    case 'no_memo':
      return { noMemo: value };
    case 'q':
      return { q: value };
    case 'other_search':
      return { otherSearch: value };
    case 'bonus_target':
      return { bonusTarget: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfDetails = (fieldName, value) => {
  switch (fieldName) {
    case 'offices': {
      return !_.isEmpty(value) ? { client_branch_ids: value.replace(/,/g, '_') } : null;
    }
    case 'groups': {
      return !_.isEmpty(value) ? { group_ids: value.replace(/,/g, '_') } : null;
    }
    case 'positions':
      return !_.isEmpty(value) ? { position_ids: value.join('_') } : null;
    case 'employmentTypes':
      return !_.isEmpty(value) ? { employment_type_ids: value.join('_') } : null;
    case 'occupations':
      return !_.isEmpty(value) ? { occupation_ids: value.join('_') } : null;
    case 'memoColors':
      return !_.isEmpty(value) ? { memo_color_ids: value.join('_') } : null;
    case 'payrollRuleGroup':
      return !_.isEmpty(value) ? { payroll_rule_group: value } : null;
    case 'noMemo':
      return !_.isEmpty(value) ? { no_memo: value } : null;
    case 'q':
      return !_.isEmpty(value) ? { q: value } : null;
    case 'otherSearch':
      return !_.isEmpty(value) ? { other_search: value } : null;
    case 'bonusTarget':
      return !_.isEmpty(value) ? { bonus_target: value } : null;
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfPays = (fieldName, value) => {
  switch (fieldName) {
    case 'payroll_rules_groups':
      return { uniquePayrollRuleGroups: value };
    case 'year_month':
      return { uniquePaymentDate: value };
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'per_page':
      return { limit: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfPays = (fieldName, value) => {
  switch (fieldName) {
    case 'uniquePayrollRuleGroups':
      return !_.isEmpty(value) ? { payroll_rules_groups: value } : null;
    case 'uniquePaymentDate':
      return !_.isEmpty(value) ? { year_month: value } : null;
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'limit':
      return { per_page: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfWithholdingReports = (fieldName, value) => {
  switch(fieldName) {
    case 'year':
      return !_.isEmpty(value) ? { year: value } : null;
    case 'resign':
      return { resign: value };
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'limit':
      return { per_page: value };
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfBonuses = (fieldName, value) => {
  switch (fieldName) {
    case 'client_bonus_id':
      return { clientBonusId: value };
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'per_page':
      return { limit: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfBonuses = (fieldName, value) => {
  switch (fieldName) {
    case 'clientBonusId':
      return !_.isEmpty(value) ? { client_bonus_id: `${value}` } : null;
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'limit':
      return { per_page: value };
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfEmployees = (fieldName, value) => {
  switch (fieldName) {
    case 'enrollment_status':
      return { employmentType: value };
    case 'enrollment_statuses':
      return { enrollmentStatuses: value.split('_') };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfEmployees = (fieldName, value) => {
  switch (fieldName) {
    case 'employmentType':
      return !_.isEmpty(value) ? { enrollment_status: `${value}` } : null;
    case 'enrollmentStatuses':
      return !_.isEmpty(value) ? { enrollment_statuses: value.join('_') } : null;
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfPaging = (fieldName, value) => {
  switch (fieldName) {
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'per_page':
      return { limit: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfPaging = (fieldName, value) => {
  switch (fieldName) {
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'limit':
      return { per_page: value };
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfRevisions = (fieldName, value) => {
  switch (fieldName) {
    case 'revision_year_month':
      return { yearMonth: value };
    case 'per_page':
      return { limit: value };
    default:
      return { [_.camelCase(fieldName)]: value };
  }
};

export const convertFormToQueryFieldOfRevisions = (fieldName, value) => {
  switch (fieldName) {
    case 'yearMonth':
      return { revision_year_month: value };
    case 'limit':
      return { per_page: value };
    default:
      return { [_.snakeCase(fieldName)]: value };
  }
};

export const convertQueryToFormFieldOfNotificationOfBaseAmountRevisions = (fieldName, value) => {
  switch (fieldName) {
    case 'revision_year':
      return { yearMonth: value };
    case 'per_page':
      return { limit: value };
    default:
      return { [_.camelCase(fieldName)]: value };
  }
};

export const convertFormToQueryFieldOfNotificationOfBaseAmountRevisions = (fieldName, value) => {
  switch (fieldName) {
    case 'yearMonth':
      return { revision_year: value };
    case 'limit':
      return { per_page: value };
    default:
      return { [_.snakeCase(fieldName)]: value };
  }
};

export const convertQueryToFormFieldOfWageLedgers = (fieldName, value) => {
  switch (fieldName) {
    case 'year':
      return { year: value };
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'per_page':
      return { limit: value };
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfWithholdingReports = (fieldName, value) => {
  switch (fieldName) {
    case 'year':
      return { year: value };
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'per_page':
      return { limit: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfWageLedgers = (fieldName, value) => {
  switch (fieldName) {
    case 'year':
      return !_.isEmpty(value) ? { year: `${value}` } : null;
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'limit':
      return { per_page: value };
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfClientRoleUsers = (fieldName, value) => {
  switch (fieldName) {
    case 'client_role_ids':
      return { clientRoles: value.split('_') };
    case 'enrollment_statuses':
      return { enrollmentStatuses: value.split('_') };
    default:
      return null;
  }
};

export const DUMMY_ID_CLIENT_ROLE_ALL = '-1';
export const convertFormToQueryFieldOfClientRoleUsers = (fieldName, value) => {
  switch (fieldName) {
    case 'clientRoles':
      // 「すべて」が選択されているときはパラメタを送らない
      if (_.isEmpty(value) || value === DUMMY_ID_CLIENT_ROLE_ALL) {
        return null;
      }
      return { client_role_ids: value };
    case 'enrollmentStatuses':
      return !_.isEmpty(value) ? { enrollment_statuses: value.join('_') } : null;
    case 'accountType':
      if (_.isEmpty(value)) {
        return null;
      }
      // 片方だけチェックがついているときのみパラメタにセットする
      // (両方ともチェックがついているときは、フィルタなしと同じためパラメタを送らない)
      return value.length === 1 ? { account_type: value[0] } : null;
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfReportHealthInsuranceBonus = (fieldName, value) => {
  switch (fieldName) {
    case 'bonusId':
      return { bonusId: value };
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'per_page':
      return { limit: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfReportHealthInsuranceBonus = (fieldName, value) => {
  switch (fieldName) {
    case 'bonusId':
      return !_.isEmpty(String(value)) ? { bonusId: `${value}` } : null;
    case 'page':
      return { page: value };
    case 'sort':
      return { sort: value };
    case 'order':
      return { order: value };
    case 'limit':
      return { per_page: value };
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfAuditLogs = (fieldName, value) => {
  switch (fieldName) {
    case 'startDate':
      return { startDate: `${value}` };
    case 'endDate':
      return { endDate: `${value}` };
    case 'page':
      return { page: value };
    case 'per_page':
      return { limit: value };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfAuditLogs = (fieldName, value) => {
  switch (fieldName) {
    case 'startDate':
      return !_.isEmpty(value) ? { start_date: `${value}` } : null;
    case 'endDate':
      return !_.isEmpty(value) ? { end_date: `${value}` } : null;
    case 'page':
      return { page: value };
    case 'limit':
      return { per_page: value };
    default:
      return null;
  }
};

export const convertQueryToFormFieldOfIncomeTaxDeclarations = (fieldName, value) => {
  switch (fieldName) {
    case 'year':
      return { year: value };
    case 'exported':
      return { exported: value };
    case 'q':
      return { q: value };
    case 'client_branch_ids':
      return { offices: value.replace(/_/g, ',') };
    default:
      return null;
  }
};

export const convertFormToQueryFieldOfIncomeTaxDeclarations = (fieldName, value) => {
  switch (fieldName) {
    case 'year':
      return value != null && value !== '' ? { year: `${value}` } : null;
    case 'exported':
      return !_.isEmpty(value) && value !== '' ? { exported: value } : null;
    case 'q':
      return !_.isEmpty(value) ? { q: value } : null;
    case 'offices':
      return !_.isEmpty(value) ? { client_branch_ids: value.replace(/,/g, '_') } : null;
    default:
      return null;
  }
};
